import { render, staticRenderFns } from "./TaskListAddNew.vue?vue&type=template&id=72b3e5a1&"
import script from "./TaskListAddNew.vue?vue&type=script&lang=js&"
export * from "./TaskListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./TaskListAddNew.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TaskListAddNew.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports